import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Es difícil encontrar los ingredientes?',
    a: 'No, el manual incluye una guía de sustitutos que encuentras en cualquier ciudad.'
  }, {
    q: '¿Necesito herramientas profesionales?',
    a: 'Solo un horno convencional, una sartén y un molde básico.'
  }, {
    q: '¿Cuánto tiempo toma?',
    a: 'Aproximadamente 90 minutos de principio a fin.'
  }, {
    q: '¿Puedo vender estos pasteles?',
    a: 'Absolutamente, es el producto de mayor tendencia actualmente.'
  }];
  return <section className="py-24 px-6 bg-dark-lighter" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-23">
          <h2 className="font-serif text-3xl md:text-4xl text-cream mb-4" data-id="element-24">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="border border-white/10 rounded-lg overflow-hidden bg-dark" data-id="element-26">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-27">
                <span className="font-serif text-lg text-cream" data-id="element-28">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-29" />
              </button>
              <AnimatePresence data-id="element-30">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-31">
                    <div className="px-6 pb-5 pt-0 text-cream-muted font-sans" data-id="element-32">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}